import type { PropsWithoutRef, SVGProps } from "react";

const AVATAR_FILL = "var(--color-brand-secondary)";

export default function FallbackAvatarIcon({ ...props }: PropsWithoutRef<SVGProps<SVGElement>>) {
	return (
		<svg
			width="130"
			height="130"
			viewBox="0 0 130 130"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M65 0C29.0927 0 0 29.0927 0 65C0 100.907 29.0927 130 65 130C100.907 130 130 100.907 130 65C130 29.0927 100.907 0 65 0ZM65 25.1613C77.7379 25.1613 88.0645 35.4879 88.0645 48.2258C88.0645 60.9637 77.7379 71.2903 65 71.2903C52.2621 71.2903 41.9355 60.9637 41.9355 48.2258C41.9355 35.4879 52.2621 25.1613 65 25.1613ZM65 115.323C49.6149 115.323 35.8286 108.351 26.6028 97.4476C31.5302 88.1693 41.1754 81.7742 52.4194 81.7742C53.0484 81.7742 53.6774 81.879 54.2802 82.0625C57.6875 83.1633 61.252 83.871 65 83.871C68.748 83.871 72.3387 83.1633 75.7197 82.0625C76.3226 81.879 76.9516 81.7742 77.5806 81.7742C88.8246 81.7742 98.4698 88.1693 103.397 97.4476C94.1714 108.351 80.3851 115.323 65 115.323Z"
				fill={AVATAR_FILL}
				fillOpacity={0.1}
			/>
		</svg>
	);
}
